import { useContext } from "react";
import { ConfigContext } from "./ConfigProvider.js";

export default function useConfig() {
  const ctx = useContext(ConfigContext);
  if (!ctx) {
    throw new Error("useConfig must be used inside a ConfigProvider");
  }
  return ctx;
}
